import { defineMessages } from 'react-intl';

export default defineMessages({
    edit: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Remove',
        defaultMessage: 'Remove'
    },
    addDriver: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Add Driver',
        defaultMessage: 'Add driver'
    },
    addExcludedDriver: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Add Excluded Driver',
        defaultMessage: 'Add Excluded Driver'
    },
    addHouseholdMember: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Add Household Member',
        defaultMessage: 'Add Household Member'
    },
    householdMembers: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Household members',
        defaultMessage: 'Household members'
    },
    addNonDrivers: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Add Non Drivers',
        defaultMessage: 'Add Non Drivers'
    },
    nonDrivers: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Non Drivers',
        defaultMessage: 'Non Drivers'
    },
    HowToChangeFromHouseholdMember: {
        id: 'ml.gateway.MLDriverChangeTablePopup.How to change from household member?',
        defaultMessage: 'How to change from household member?'
    },
    changeToRatedDriver: {
        id: 'ml.gateway.MLDriverChangeTablePopup.To change to a rated driver',
        defaultMessage: 'To change to a rated driver, click on Remove and select I need to insure this driver. To change to an excluded driver, click on Remove and select the applicable reason.'
    },
    excludedDrivers: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Excluded drivers',
        defaultMessage: 'Excluded drivers'
    },
    HowToChangeFromExcludedDriver: {
        id: 'ml.gateway.MLDriverChangeTablePopup.How to change from excluded driver?',
        defaultMessage: 'How to change from excluded?'
    },
    changeFromExluded: {
        id: 'ml.gateway.MLDriverChangeTablePopup.To change to from excluded',
        defaultMessage: 'To change to a rated driver, click on Remove and select I need to insure this driver. To change to a household member, click on Remove and select the applicable reason.'
    },
    changeFromExludedNonDriver: {
        id: 'ml.gateway.MLDriverChangeTablePopup.To change to from excluded non driver',
        defaultMessage: 'To change to a rated driver, click on Remove and select I need to insure this driver. To change to a non driver, click on Remove and select the applicable reason.'
    },
    addNewDriver: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Add a new driver',
        defaultMessage: 'Add a new driver'
    },
    noExcludedMembers: {
        id: 'ml.gateway.MLDriverChangeTablePopup.No household members have been excluded',
        defaultMessage: 'No household members have been excluded'
    },
    noExcludedNonDrivers: {
        id: 'ml.gateway.MLDriverChangeTablePopup.No non drivers have been excluded',
        defaultMessage: 'No non drivers have been excluded'
    },
    belowAreExcluded: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Below are the members of the household which are excluded',
        defaultMessage: 'Below are the members of the household which are excluded'
    },
    belowNonDriversAreExcluded: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Below are the non drivers which are excluded',
        defaultMessage: 'Below are the non drivers which are excluded'
    },
    householdMemberHeader: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Tell us about any additional household members who are not listed',
        defaultMessage: 'Tell us about any additional household members who are not listed'
    },
    nonDriverHeader: {
        id: 'ml.gateway.MLDriverChangeTablePopup.Tell us about any additional non drivers who are not listed',
        defaultMessage: 'Tell us about any additional non drivers who are not listed'
    },
    HowToChangeFromNonDriver: {
        id: 'ml.gateway.MLDriverChangeTablePopup.How to change from non driver?',
        defaultMessage: 'How to change from non driver?'
    },
});